import { render, staticRenderFns } from "./ResolveModal.vue?vue&type=template&id=388d95e6&scoped=true&"
import script from "./ResolveModal.vue?vue&type=script&lang=js&"
export * from "./ResolveModal.vue?vue&type=script&lang=js&"
import style0 from "./ResolveModal.vue?vue&type=style&index=0&id=388d95e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d95e6",
  null
  
)

export default component.exports